import { render, staticRenderFns } from "./BusinessSetting.vue?vue&type=template&id=37565678&scoped=true&"
import script from "./BusinessSetting.vue?vue&type=script&lang=js&"
export * from "./BusinessSetting.vue?vue&type=script&lang=js&"
import style0 from "./BusinessSetting.vue?vue&type=style&index=0&id=37565678&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37565678",
  null
  
)

export default component.exports